export enum ToolbarTestIds {
  Root,
  Tab,
  CaseTitle,
  DocketNumber,
  PdfSwitch = 'a',
}
